import React, { useState, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import axiosInstance from "../components/api/axiosInstance";
import { fetchOfficeServiceById } from "./supportContactService";
import "../assets/css/ViewCustomer.css";
import "../assets/css/EditTenant.css";
import "../assets/css/Projects.css";
import "../assets/css/Tasks.css";

function ViewSupportContact({ contactId, onBack, onEdit }) {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContact = async () => {
      setLoading(true);
      try {
        // Try office-service first (for Service tab)
        let c = await fetchOfficeServiceById(contactId);
        let isOfficeService = !!c;
        if (!c) {
          // Fallback to support-contact (for Staff tab)
          const response = await axiosInstance.get(`/support-contact/${contactId}`);
          const raw = response?.data?.data ?? response?.data;
          c = raw?.Support_Contact_Id ? raw : (raw?.support_contact || raw);
        }
        if (c) {
          setContact({
            isOfficeService,
            id: c.Id ?? c.Support_Contact_Id ?? c.support_contact_id ?? c.id,
            contactType: c.Contact_Type ?? c.contact_type ?? "Service",
            serviceName: c.Service_Name ?? c.service_name ?? c.name ?? "",
            category: c.Service_Category ?? c.service_category ?? c.Category ?? c.category ?? "",
            status: c.Status ?? c.status ?? "Active",
            primaryContactName: c.Contact_Name ?? c.contact_name ?? c.Primary_Contact_Name ?? c.primary_contact_name ?? "",
            primaryContact: c.Primary_Contact ?? c.primary_contact ?? "",
            primaryContactPhone: c.Contact_Phone ?? c.contact_phone ?? c.Primary_Contact_Phone ?? c.primary_contact_phone ?? "",
            supportPhone: c.Contact_Phone ?? c.contact_phone ?? c.Support_Phone ?? c.support_phone ?? "",
            altPhone: c.Alt_Phone ?? c.alt_phone ?? "",
            tollFreeNumber: c.Toll_Free_Number ?? c.toll_free_number ?? "",
            supportEmail: c.Support_Email ?? c.support_email ?? "",
            supportHours: c.Support_Hours ?? c.support_hours ?? "",
            supportDays: c.Support_Days ?? c.support_days ?? "",
            notes: c.Notes ?? c.notes ?? "",
            createdAt: c.Created_On ?? c.created_on ?? c.Created_At ?? c.created_at ?? c.CreatedAt ?? ""
          });
        } else {
          setContact(null);
        }
      } catch (err) {
        console.error("Error fetching support contact:", err);
        setContact(null);
      } finally {
        setLoading(false);
      }
    };
    fetchContact();
  }, [contactId]);

  const InfoItem = ({ label, value }) => {
    const hasValue = value != null && value !== "" && value !== "—";
    return (
      <div className="viewlead-info-item">
        <span className={`viewlead-info-label ${hasValue ? "has-value" : ""}`}>{label}: </span>
        <span className={`viewlead-info-value ${!hasValue ? "muted" : ""}`}>{hasValue ? value : "—"}</span>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="viewlead-container">
        <div className="viewlead-loading">Loading contact details...</div>
      </div>
    );
  }

  if (!contact) {
    return (
      <div className="viewlead-container">
        <button type="button" className="viewlead-back-link" onClick={onBack}>
          <FaArrowLeft /> Back
        </button>
        <div
          className="error-message"
          style={{ backgroundColor: "#fee", color: "#c33", padding: "12px", borderRadius: "4px", marginTop: "16px" }}
        >
          Contact not found.
        </div>
      </div>
    );
  }

  return (
    <div className="viewlead-container">
      <div className="viewlead-header">
        <button type="button" className="viewlead-back-link" onClick={onBack}>
          <FaArrowLeft /> Back
        </button>
        <button type="button" className="btn-subproject-primary" onClick={() => onEdit && onEdit(contactId, contact.isOfficeService)}>
          Edit
        </button>
      </div>

      <div className="viewlead-card" style={{ marginBottom: 20 }}>
        <h3 className="viewlead-section-title">Service Information</h3>
        <div className="viewlead-info-grid">
          <InfoItem label="Service ID" value={String(contact.id)} />
          <InfoItem label="Service Name" value={contact.serviceName} />
          <InfoItem label="Service Category" value={contact.category} />
          <InfoItem label="Status" value={contact.status} />
          <InfoItem label="Contact Name" value={contact.primaryContactName} />
          <InfoItem label="Contact Phone" value={contact.primaryContactPhone} />
          <InfoItem label="Alt Phone" value={contact.altPhone} />
          <InfoItem label="Toll-Free" value={contact.tollFreeNumber} />
          <InfoItem label="Support Email" value={contact.supportEmail} />
          <InfoItem label="Support Hours" value={contact.supportHours} />
          <InfoItem label="Support Days" value={contact.supportDays} />
        </div>

        <h3 className="viewlead-section-title">Notes</h3>
        <div className="viewlead-info-grid">
          <InfoItem label="Notes" value={contact.notes} />
        </div>
      </div>
    </div>
  );
}

export default ViewSupportContact;

